export default "__VITE_ASSET__b433099d__"